/**
 * Lightweight IIR (Intelligence Information Report) product type.
 * Stored in generic_documents collection "iirs" with payload { name, question, ... }.
 */
import {getCollection, getDoc, setDoc, deleteDoc} from './firestore';
import {PRODUCT_TYPE_IIR} from '../../features/products/productTypes';

const COLLECTION = 'iirs';

function normalize(row) {
    if (!row) return null;
    return {
        id: row.id,
        name: row.name || '',
        question: row.question || '',
        createdAt: row.createdAt || null,
        createdBy: row.createdBy || null,
        updatedAt: row.updatedAt || null,
        productType: PRODUCT_TYPE_IIR,
    };
}

export async function listIirs() {
    const rows = await getCollection(COLLECTION);
    return (rows || []).map(normalize).filter(Boolean);
}

export async function getIir(id) {
    const data = await getDoc(COLLECTION, id);
    return normalize(data);
}

export async function createIir({name, question, createdBy}) {
    const id = (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : `iir-${Date.now()}`;
    const payload = {
        id,
        name: (name || '').trim(),
        question: (question || '').trim(),
        productType: PRODUCT_TYPE_IIR,
        createdAt: new Date().toISOString(),
        createdBy: createdBy || null,
    };
    await setDoc(COLLECTION, id, payload);
    return payload;
}

export async function updateIir(id, fields) {
    const existing = await getIir(id);
    const payload = {
        ...existing,
        ...fields,
        id,
        name: (fields.name ?? existing?.name ?? '').trim(),
        question: (fields.question ?? existing?.question ?? '').trim(),
        productType: PRODUCT_TYPE_IIR,
        updatedAt: new Date().toISOString(),
    };
    await setDoc(COLLECTION, id, payload);
    return payload;
}

export async function deleteIir(id) {
    await deleteDoc(COLLECTION, id);
}
